export default __webpack_public_path__ + "static/media/pinkTheme-boy.dee5f707.svg";